<template>
  <base-slide-panel :isOpen="panelOpen" @closePanel="togglePanel">
    <template slot="header">
      <div class="h-16 bg-secondary dark:bg-darkblue-600 flex items-center justify-between text-white px-4">
        <div class="flex items-center">
          <base-icon name="filter" />
          <h2 class="font-bold ml-2">{{ $t('app.filter_by') }}</h2>
        </div>
        <span class="cursor-pointer" @click="togglePanel">
          <base-button-icon name="cross" size="xs" iconSize="sm" mode="secondary" />
        </span>
      </div>
    </template>
    <template slot="main">
      <div class="form-wrapper p-4 dark:bg-darkblue-800 dark:text-darkblue-200">
        <el-form ref="ruleForm">
          <div class="lg:mb-2">
            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('companies.configuration_rec.pge') }}</label>
              <el-form-item prop="PGE">
                <base-el-select class="w-full" :options="pges" v-model="form.PGE.value" clearable filterable :disabled="isLoadingSelect" />
              </el-form-item>
            </div>
          </div>
          <div class="lg:mb-2">
            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('companies.configuration_rec.dir3_dire') }}</label>
              <el-form-item prop="DIR">
                <el-input clearable class="w-full" v-model="form.DIR.value" maxlength="100" />
              </el-form-item>
            </div>
          </div>
        </el-form>
      </div>
    </template>
    <template slot="footer">
      <base-button @click="togglePanel" mode="secondary-phantom-blue" :text="$t('app.cancel')" :loading="isLoadingSelect"
        :disabled="isLoadingSelect" />
      <base-button mode="secondary-phantom-blue" class="w-full" :text="$t('app.apply')" @click="applyFilters" :loading="isLoadingSelect"
        :disabled="isLoadingSelect" />
    </template>
  </base-slide-panel>
</template>

<script>
// import _ from 'lodash'
import { i18n } from '@/i18n'

// import { mapGetters } from 'vuex'

export default {
  /* eslint-disable camelcase */
  name: 'filter-panel',
  props: {
    panelOpen: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      vuexnamespace: 'companiespge',
      isOpen: this.panelOpen,
      form: {
        PGE: { label: i18n.t('companies.configuration_rec.pge'), value: [], labelValue: '' },
        DIR: { label: i18n.t('companies.configuration_rec.dir3_dire'), value: '' }
      },
      isLoadedData: false,
      loadingActionSelect: false,
      loadingActionUnSelect: false
    }
  },
  mounted: async function () {
    this.isLoadedData = false
    this.$store.dispatch('app/settiposPGE', this.tiposPge)
    this.isLoadedData = true
  },
  watch: {
    form: {
      deep: true,
      immediate: true,
      handler: 'watchFormHandler'
    },
    panelOpen: {
      handler: 'panelOpenHandler'
    }
  },
  methods: {
    panelOpenHandler: function (data) {
      const _temp = this.$store.getters[this.vuexnamespace + '/getMasterFilters']
      if (_temp) {
        this.resetForm()
        this.form.PGE.value = _temp.PGE !== undefined && _temp.PGE.value.length > 0 ? _temp.PGE.value : ''
        this.form.DIR.value = _temp.DIR !== undefined && _temp.DIR.value !== '' ? _temp.DIR.value : ''
      }
    },
    watchFormHandler: function () {
    },
    togglePanel: function () {
      this.isOpen = !this.isOpen
      // this.resetForm()
      this.$emit('togglePanel')
    },
    resetForm: function () {
      this.form = {
        PGE: { label: i18n.t('companies.configuration_rec.pge'), value: [], labelValue: '' },
        DIR: { label: i18n.t('companies.configuration_rec.dir3_dire'), value: '' }
      }
    },
    applyFilters: function () {
      if (this.form.PGE.value.length > 0) this.controlLabelPGE(this.form.PGE.value)
      else this.form.PGE.value = ''
      this.$store.commit(this.vuexnamespace + '/setMasterFilters', this.form)
      this.$emit('applyFilters', true)
      this.isOpen = !this.isOpen
      this.resetForm()
      this.$emit('togglePanel')
    },
    handleSelectAll: async function () {
      await this.handleUnSelectAll()
      this.loadingActionSelect = true
      this.pges.forEach(element => {
        setTimeout(() => {
          this.form.PGE.value.push(element.id)
          if (this.form.PGE.value.length === this.pges.length) {
            this.loadingActionSelect = false
            this.loadingActionUnSelect = false
          }
        }, 100)
      })
    },
    handleUnSelectAll: async function () {
      this.loadingActionUnSelect = true
      const staticLength = this.form.PGE.value.length
      for (let index = 0; index < staticLength; index++) {
        setTimeout(() => {
          this.form.PGE.value.pop()
          if (this.form.PGE.value.length === 0) this.loadingActionUnSelect = false
        }, 100)
      }
    },
    controlLabelPGE: function (value) {
      if (!(value instanceof Array)) {
        value = [value]
      }
      const PGE = this.pges.filter(x => {
        return value.includes(x.id)
      })
      if (PGE !== null && PGE !== undefined) {
        if (PGE.length === 0) {
          this.form.PGE.labelValue = ''
          this.form.PGE.value = ''
        } else if (PGE.length === 1) {
          this.form.PGE.labelValue = PGE[0].name
        } else {
          this.form.PGE.labelValue = PGE.length
        }
      }
    },
  },
  computed: {
    tiposPge: function () {
      return this.$store.getters['config/TIPOS_PGE_RECEPCION']
    },
    pges: function () {
      return this.tiposPge.filter(x => !['OCR', 'FILES', 'AUTOFACTURA', 'MANUAL'].includes(x.id))
    },
    isEmptyList: function () {
      return this.pges === undefined || this.pges === null || this.pges.length === 0
    },
    isLoadingSelect: function () {
      return this.loadingActionUnSelect || this.loadingActionSelect
    },
    isAllSelected: function () {
      if (this.pges.length === this.form.PGE.value.length) return true
      else return false
    },
  }
}
</script>

<style lang="scss" scoped></style>
